import React from "react";
import rahel from "./../../../img/rahel1.jpg";
import Header from "./ArabicPrint/Header";
const PrintArabicMoney = () => {
    return (
        <>
            <img src={rahel} alt="rahel" />
            <Header />
        </>
    );
};

export default PrintArabicMoney;
